<template>
  <div class="product-color-picker flex max-w-full">
    <div
      class="product-color-picker-label flex items-center"
    >
      <span v-text="`${$t('Loyalty.Webshop.ProductDetail.Color')}:`" />
    </div>
    <div class="flex max-w-full flex-wrap">
      <NuxtLink
        v-for="(option, i) in options"
        :key="i"
        :to="option.slug"
        class="product-color-picker-link"
      >
        <div class="cursor-pointer w-7 h-7">
          <div
            class="pallete"
            :style="{
              backgroundColor: option.color
            }"
          >
            <div
              v-if="option.color === '#ffffff'"
              class="pallete--inner"
            />
          </div>
        </div>
      </NuxtLink>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductColorPicker',
  props: {
    options: {
      type: Array,
      default: () => ([]),
      validator: array => array.every(obj => ['color', 'slug'].every(prop => obj.hasOwnProperty(prop)))
    }
  }
}
</script>

<style lang="postcss" scoped>
.product-color-picker {

  &-link {
    padding: .3rem;
    margin: 0 .3rem;
    border-radius: .5rem;
  }

  >>> .nuxt-link-exact-active {
    @apply border border-gray-600;
    padding: .2rem;
  }

  &-label {
    margin-right: .5rem;
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 2.4rem;
  }

  .pallete {
    @apply rounded-md w-7 h-7;

    &--inner {
      @apply rounded-md border border-gray-200 h-full w-full;
    }
  }
}
</style>
